export const DELETED_USER_LABEL = 'Удалённый аккаунт'

type DeletedUserLike = {
  deleted?: boolean
  fullname?: string | null
  shortname?: string | null
  name?: string | null
  avatar?: string | null
  slug?: string | null
  id?: number | null
}

export function isDeletedUser(user: DeletedUserLike | null | undefined): boolean {
  return user?.deleted === true
}

export function resolveUserDisplayName(
  user: DeletedUserLike | null | undefined,
  fallback = 'Пользователь'
): string {
  if (isDeletedUser(user)) {
    return DELETED_USER_LABEL
  }

  const name = (user?.fullname ?? user?.shortname ?? user?.name ?? '').trim()
  return name || fallback
}

export function resolveUserAvatarUrl(
  user: DeletedUserLike | null | undefined
): string | undefined {
  if (isDeletedUser(user)) {
    return undefined
  }

  const avatar = user?.avatar?.trim()
  return avatar ? avatar : undefined
}

export function canNavigateToUserProfile(user: DeletedUserLike | null | undefined): boolean {
  if (isDeletedUser(user)) {
    return false
  }

  return Boolean((user?.slug ?? '').trim())
}

export function getUserInitialsFromDisplayName(name: string): string {
  const value = name.trim()
  if (!value) return '?'
  const parts = value.split(/\s+/).filter(Boolean)
  const first = parts[0]?.[0] ?? ''
  const second = (parts[1]?.[0] ?? parts[0]?.[1] ?? '') ?? ''
  return (first + second).toUpperCase()
}
